<template>
  <strong><label :style="{ 'font-size': fontSize }">{{ labelText }}</label></strong>
  <label :style="{ 'font-size': fontSize, 'margin-left': '10px' }">{{
    fileLimitText
  }}</label>

  <div class="input-group mb-3 mt-2">
    <label class="input-file-size" for="input_file">
      <svg v-if="urlImg == ''" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#9F3029"
        class="bi bi-file-earmark-arrow-up svg-style" viewBox="0 0 16 16">
        <path
          d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z" />
        <path
          d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
      </svg>
      <img v-if="urlImg != ''" :src="img" style="margin: 0px; max-height: 80px; left: 0; top: 0; border-radius: 50%;"
        class="bi bi-file-earmark-arrow-up svg-style" />
      <h5 v-if="hasFile == true" class="anexo-title">- {{ file.name }}</h5>
      <h5 v-if="file == null && uploadSucesso == false" class="text-muted">
        - Clique aqui para selecionar o arquivo
      </h5>
    </label>
    <input type="file" name="input_file" ref="input_file" id="input_file" class="form-control shadow-v2"
      :multiple="multiple" :disabled="disable" :class="{ filled: file }" @change="handleFileChange"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf, .jpg, .png, .txt, .docx, image/png, image/jpg, image/gif, image/jpeg" />

    <div class="div-upload col-1 line-card ml-10" :class="{ 'bg-color-green': hasFile, 'bg-color-red': !hasFile }"></div>
    <label class="form-label wait-file" v-if="file == null && uploadSucesso == false">Aguardando a seleção do
      arquivo...</label>
    <label class="form-label wait-file text-warning" v-if="file != null && uploadSucesso == false">
      Arquivo Pronto para Upload!</label>
    <label class="form-label wait-file" style="color: green" v-if="file != null && uploadSucesso == true">Sucesso no
      Upload do Arquivo!</label>

    <div class="buttonUpload" v-if="file != null && uploadSucesso == false">
      <button type="button" class="btn-white shadow-v2" @click="uploadFile" style="margin-top: 10px; float: right">
        <i class="fas fa-cloud-upload-alt"></i><span style="margin-left: 8px;">Upload Anexo</span>
      </button>
    </div>
    <Field name="file" label="Arquivo" type="hidden" v-model="file" />
    <ErrorMessage name="file" class="form-error" />
  </div>
  <div v-if="uploadSucesso == true" style="min-width: 50%">
    <div class="wait-file">
      <span class="ml-10"><i class="fas fa-file-alt icon-size ml-10"></i> {{ file.name }}</span>
      <button type="button" class="btn-grid-excluir-lista" @click="excluirAnexo()" style="float: right">
        <i class="fa fa-trash" aria-hidden="true"></i><span class="btn-span-text">Excluir</span>
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  emits: ["onSave"],

  props: {
    labelText: {
      type: String,
      required: true,
      default: "Upload Anexo",
    },
    fontSize: {
      type: String,
      default: "14px",
    },
    fileLimitText: {
      type: String,
      default: "Limite de arquivos até 50MB.",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    urlUpload: {
      type: String,
      required: true,
    },
    urlImg: {
      type: String,
      // required: true,
    },
  },
  data() {
    return {
      file: null,
      uploadSucesso: false,
      disable: false,
      hasFile: false,
      img: "",
    };
  },
  methods: {
    handleFileChange(event) {
      this.file = event.target.files[0];

      if (this.file == null) {
        this.hasFile = false;
      } else {
        this.hasFile = true;
      }
    },
    excluirAnexo() {
      this.uploadSucesso = false;
      this.file = null;

      document.getElementById("input_file").value = "";

      this.hasFile = false;
      this.disable = false;
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("file", this.file);

      axios
        .post(this.urlUpload, formData, {
          headers: "",
        })
        .then((response) => {
          this.$emit("onSave", response.data.data);

          this.hasFile = true;
          this.disable = true;

          this.uploadSucesso = true;

          this.$toast.show("success", "Upload concluído com sucesso.", true);
        })
        .catch((error) => {
          this.$toast.show("alert", "Selecione um arquivo válido...", true);
        });
    },
    async getImagem() {
      let response = await axios.get(
        process.env.VUE_APP_ROOT_AUTENTICACAO_API +
        "/Usuario/GetShowImage?dsHash=" +
        this.$api.getHash() +
        "&url=" +
        this.urlImg
      );
      this.img = response.data.data;
    },
    resetVariaveis() {
      this.file = null;
      this.uploadSucesso = false;
      this.disable = false;
      this.hasFile = false;
    },
  },
  watch: {
    urlImg(newVal, oldVal) {
      let $this = this;
      if (newVal != "") {
        $this.getImagem();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.buttonUpload {
  min-width: 24.5%;
}

.ml-10 {
  margin-left: 10px !important;
}

.wait-file {
  margin-left: 10px !important;
  margin-top: 25px !important;
  font-size: 14px !important;
}

.input-file-size {
  border-radius: 0px;
  min-height: 80px;
  height: 80px;
  width: 50%;
  max-width: 50%;
  border: 2px dashed grey;
  cursor: pointer;

  .anexo-title {
    font-size: 16px;
    color: #ab0000;
    margin-left: 15%;
    padding-top: 3%;
    font-size: 16px;
  }

  .text-muted {
    margin-left: 15%;
    padding-top: 3.5%;
    font-size: 14px;
  }
}

#input_file {
  display: none;
}

.svg-style {
  position: absolute;
  left: 10px;
  top: 15px;
}

.mt-35 {
  margin-top: 35px;
}

.file-campo {
  border: 1px dashed #f4f4f4;
}

.btn-green {
  font-weight: 700;
  border-radius: 5px !important;
}

.btn-red {
  border-radius: 5px !important;
}

.line-card {
  max-width: 10px;
  margin-left: -3px;
  margin-top: -1px;
  margin-bottom: -2px;
}

.bg-color-red {
  background-color: #ab0000;
}

.bg-color-green {
  background: #34a853;
}

.icon-size {
  height: 50px;
  color: #34a853;
}

@media screen and (max-width: 1400px) {
  .input-file-size {
    .text-muted {
      margin-left: 25%;
      padding-top: 5.5%;
    }

    .anexo-title {
      margin-left: 25%;
      padding-top: 5%;
    }
  }

  .line-card {
    margin-left: 5px !important;
  }

  .buttonUpload {
    min-width: 100%;
  }
}
</style>
